import { render, staticRenderFns } from "./Salva.vue?vue&type=template&id=50f4d041"
import script from "./Salva.vue?vue&type=script&lang=js"
export * from "./Salva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports